import { mergeStyleSets } from '@fluentui/react';
import AppContext, { IAppContext } from 'App/AppContext';
import HrefLink from 'components/Links/HrefLink';
import { globalWebsiteURL } from 'globalConstants';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Config from 'services/Config/configService';

// Temporary campaign banner: In Good Company 26 — swap the image and URL for the next campaign
const eventBannerImageUrl = `${Config.getImageURL()}/in-good-company-26.webp`;
export const eventBannerRegistrationUrl = `${globalWebsiteURL}/events/in-good-company-26`;

// The campaign ends after the event day; banner and coachmark then hide themselves
const eventEndDate = new Date('2026-09-25T23:59:59');

export const isIsoEventActive = (appContext: IAppContext): boolean =>
  appContext.user.language.code === 'nl' && new Date() <= eventEndDate;

const IsoEventBanner = () => {
  const { t } = useTranslation(['translation']);
  const appContext = useContext(AppContext);

  const styles = mergeStyleSets({
    promo: {
      display: 'block',
      width: 400,
      maxWidth: '100%',
      borderRadius: 4,
    },
  });

  // The campaign artwork and event page are Dutch-only, and only run until the event date
  if (!isIsoEventActive(appContext)) {
    return null;
  }

  return (
    <HrefLink href={eventBannerRegistrationUrl} newTab>
      <img
        className={styles.promo}
        src={eventBannerImageUrl}
        alt={t('translation:NavBar.UserDialog.EventBanner-Text')}
      />
    </HrefLink>
  );
};

export default IsoEventBanner;
